<div class="container">
    <div class="icon-logo-color">
        <mat-icon>
            <img src="assets/icons/pn-logo-color.svg"/>
        </mat-icon>
    </div>
    <h2 class="title">Registration link not found</h2>
    <div class="description">
        <p>
            Your registration link is invalid or not found. 
        </p>
        <p>Please contact your administration to send another link.</p>
    </div>
</div>